<template>
<div>
  <v-container
          class="fill-height"
          fluid
        >
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-text-field
        v-model="name"
        :counter="3"
        :rules="nameRules"
        label="Name"
        required
      ></v-text-field>

      <v-text-field
        v-model="url"
        :counter="3"
        :rules="urlRules"
        label="URL"
        required
      ></v-text-field>

      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        required
      ></v-text-field>
  
      <v-select
        v-model="select"
        :items="items"
        :rules="[v => !!v || 'Item is required']"
        label="Item"
        required
      ></v-select>
  
      <v-file-input v-model="files" show-size counter multiple label="File input" @change="onUpload"></v-file-input>

      <v-checkbox
        v-model="checkbox"
        :rules="[v => !!v || 'You must agree to continue!']"
        label="Do you agree?"
        required
      ></v-checkbox>
  
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="validate"
      >
        Validate
      </v-btn>
  
      <v-btn
        color="error"
        class="mr-4"
        @click="reset"
      >
        Reset Form
      </v-btn>
  
      <v-btn
        color="warning"
        @click="resetValidation"
      >
        Reset Validation
      </v-btn>
    </v-form>
    </v-container>

    <v-container>
    <progress id="progress" :value="uploadValue" max="100" ></progress>
    <div v-for="(item,index) in imgs" :key="index">
      <img :src="item" class="img">
    </div>
  </v-container>

</div>
</template>

<style>
.img{width:200px;}
</style>

<script>
  import { storage } from '../main.js';

  export default {
    name: 'NewProduct',
    props:{
    },
    data: () => ({
        valid: true,
        name: '',
        nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        url: '',
        urlRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 10) || 'Name must be less than 10 characters',
        ],
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        select: null,
        items: [
            'Item 1',
            'Item 2',
            'Item 3',
            'Item 4',
        ],
        checkbox: false,
        files: [],
        imgs: [],
        uploadValue: 0
    }),
    computed:{
      brandsNames() {
            var res = [];
            Object.entries(this.$store.state.brands).forEach(([key, value]) => {
                res[key] = value.name;      
            });
            return res;
      },
      brandsUrls() {
            var res = [];
            Object.entries(this.$store.state.brands).forEach(([key, value]) => {
                res[key] = value.url;      
            });
            return res;
      }
    },
    methods: {
        validate () {
            var valid = this.$refs.form.validate();
            if(valid){
                var data = {'name':this.name,'url':this.url};
                if(!this.brandsNames.includes(this.name) && !this.brandsUrls.includes(this.url)){
                    this.$store.dispatch('setDataFireStore',data);
                }else{
                    alert('Brand Name or URL Already Exits');
                }
            }
        },
        reset () {
            this.$refs.form.reset()
        },
        resetValidation () {
            this.$refs.form.resetValidation()
        },
        onUpload() {
          for(var i = 0; i < this.files.length; i++) {
              var metadata = {contentType: this.files[i].type, cacheControl:'public, max-age=31536000'};
              var storageRef = storage.ref();
              var name = this.files[i].name;
              const storeUp = storageRef.child('' + name).put(this.files[i], metadata);
              storeUp.on(`state_changed`,snapshot=>{
                    this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
              }, error=>{console.log(error.message)},
              ()=>{this.uploadValue=100;
                storeUp.snapshot.ref.getDownloadURL().then((url)=>{
                  this.imgs.push(url);
                  //name = name.replace(".", "_400x600.");
                  //this.imgs.push('https://firebasestorage.googleapis.com/v0/b/vmsapp-95d7e.appspot.com/o/thumb%2F'+name+'?alt=media');
                });
              }
              );              
                        
          }
        }
    },

  }
</script>